<template>
  <div class="techAvatar">
    <div class style="width:100%;background-color:white;text-align:center;padding: 2rem 0;">
      <div class="van-uploader__upload" v-for="(item,index) in localIds" :key="index">
        <img :src="item" class="radius" alt @click="previewImage(item)" />
        <p
          class="close fs_12"
          @click="deleImg(index)"
          style="position: absolute;top: 0;right: .2rem;font-size: 1.25rem !important;color:#45b9bc;"
        >×</p>
      </div>

      <div class="van-uploader__upload" v-if="localIds.length < 1" @click="selectImg">
        <i class="van-icon van-icon-plus van-uploader__upload-icon">
          <!---->
        </i>
      </div>
    </div>

    <div class="btn_box">
      <button class="next_btn" @click="save">保存</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "techAvatar",
  components: {},
  data() {
    return {
      serverId: [],
      localIds: [],
      tech_id: 0
    };
  },
  created() {
    if (this.$route.query.tech_id) {
      this.tech_id = this.$route.query.tech_id;
    } else {
      this.$toast({
        message: "技师信息错误",
        duration: 1000,
        onClose: function() {
          this.$router.go(-1);
        }
      });
    }
    
  },
  methods: {
    post() {
        this.axios({
          url: this.api.tech.change_tech_avatar, 
          data: {
            tech_id: this.tech_id,
            localIds: this.localIds,
            thumbs: this.serverId
          }
        }).then(res => {
          if (res.error === 0) {
            this.$toast({
              message: res.msg,
              type: "success",
              onClose: () => {
                
              }
            });
          } else {
            this.$toast({
              message: res.error
            });
          }
        });
    },
    save() {
        this.post();
    },
    selectImg() {
      var that = this;
      this.axios({
        url: this.api.index.share_url,
        data: {
          url: window.location.href.split("#")[0]
        }
      }).then(function(res) {
        var shareMsg = res.jssdkconfig;
        wx.config({
          // debug:true,
          appId: shareMsg.appId,
          timestamp: shareMsg.timestamp,
          nonceStr: shareMsg.nonceStr,
          signature: shareMsg.signature,
          jsApiList: ["chooseImage", "uploadImage", "previewImage"]
        });
        wx.ready(function() {
          wx.chooseImage({
            count: 1, // 默认9
            sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
              res.localIds.forEach(v => {
                // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                that.localIds.push(v);
                if(that.localIds.length){
                  that.upLoad_img();
                }
              });
            }
          });
        });
      });
    },
    previewImage(url) {
      // 图片预览
      var that = this;

      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: that.localIds // 需要预览的图片http链接列表
      });
    },
    deleImg(i) {
      this.localIds.splice(i, 1);
    },
    upLoad_img() {
      var that = this;
      console.log(that.localIds);
      function upLoad() {
        // 多图上传
        wx.uploadImage({
          count:0,
          localId: that.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: function(res) {
            that.serverId.push(res.serverId); // 返回图片的服务器端ID
          }
        });
      }
      upLoad();
    }
  }
};
</script>
<style scoped>
.van-uploader__upload {
  width: 5rem;
  height: 5rem;
  margin: 0 auto;
}
.van-uploader__upload img {
  width: 100%;
  height: 100%;
}
.van-cell {
  border-bottom: 1px solid #eee;
}
.upload {
  background-color: white;
}
.bz {
  position: absolute;
}
.van-step--horizontal .van-step__circle-container {
  top: 45px !important;
}
.van-step--horizontal .van-step__line {
  top: 45px !important;
}
.btn_box {
  text-align: center;
}
.next_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 5rem;
  margin-top: 2.5rem;
  font-size: 0.9rem;
}
.van-steps--horizontal {
  padding: 0.75rem 2rem;
}
.tech_box li {
  background-color: white;
  padding: 0.1rem 1.25rem;
}
.van-button--primary {
  background-color: white;
  border: 1px solid #45b9bc;
  border-radius: 5px;
  color: #45b9bc;
}
.van-step--horizontal .van-step__title {
  font-size: 0.7rem;
}
.idcard_upload {
  background-color: white;
  margin: 0.1rem 1.25rem;
  padding-bottom: 1rem;
  font-size: 0.75rem;
  color: #636363;
  border-bottom: 1px solid #eee;
  clear: both;
  overflow: hidden;
}
.idcard_upload p {
  padding-bottom: 1rem;
}
.idcard_fm {
  margin-left: 1rem;
}
.agreement {
  font-size: 0.6rem;
  color: #a4a5a6;
  margin-left: 1.25rem;
  margin-top: 0.45rem;
}
.agreement_tip {
  padding-left: 0.1rem;
}
.agreement_tip span {
  color: #45b9bc;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/perData/techAvatar.vue